/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
(window as any).__Zone_disable_customElements = true;

/**
 * Fix: Chrome 144+ mouse wheel scroll ไม่ทำงานกับ Ionic ion-content
 * บังคับให้ zone.js ลงทะเบียน scroll/wheel/touch events เป็น passive
 * ทำให้ Chrome สามารถ scroll ได้ทันทีโดยไม่ต้องรอ JavaScript ประมวลผล
 */
(window as any).__zone_symbol__PASSIVE_EVENTS = ['scroll', 'wheel', 'touchstart', 'touchmove'];
